'use strict';

import React from 'react'

import { CSSTransition, TransitionGroup } from 'react-transition-group'

import _ from 'lodash'

import { capitalize } from '@root/utility'

import Layout from '@Layout/BackOffice'

import FormElement from '@/Form/toolkit/FormElement'

import { handleChange } from '@/Form/Functions/eventsHandling'

import AddCustomQuoteElement from '@/CustomQuote/AddCustomQuoteElement'
import CustomQuoteElements   from '@/CustomQuote/CustomQuoteElements'

import Loader from '@Pure/Loader'

let app = window.app;

export default class CustomQuoteUpdate extends React.Component
{
	constructor (props)
	{
		super(props);

		this.state = { };
	}

	componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		app.push(
		{
			event: 'addedCustomQuoteItem',
			cb: component.handleAddedElement
		});

		app.push(
		{
			event: 'updatedCustomQuoteItem',
			cb: component.handleUpdatedElement
		});

		component.setState(
		{
			loading: true,

			form_data: { },
			elements: [ ],
			updated: undefined
		});

		qwest.post('/CMS/getAll',
		{
			model: 'CustomQuote'.toLowerCase(),

			filter_query: JSON.stringify(
			{
				id: id
			})
		})
		.then(function (xhr, response)
		{
			let quote = response.data[0];

			component.setState(
			{
				loading: false,

				id: id,
				elements: quote.elements,
				form_data:
				{
					title: quote.title,
					admin_email: quote.admin_email || ''
				}
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(error, xhr, response);

			component.setState({ loading: false });

			app.ajaxRedirectLogin(response);
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props, state = this.state;

		app.delete(
		{
			event: 'addedCustomQuoteItem',
			cb: component.handleAddedElement
		});

		app.delete(
		{
			event: 'updatedCustomQuoteItem',
			cb: component.handleUpdatedElement
		});
	}

	handleAddedElement = (element) =>
	{
		const component = this, props = this.props, state = this.state;

		state.elements.push(
		{
			type: element.type,
			label: element.label,
			data: element.data
		});

		component.setState(
		{
			elements: state.elements,
			updated: undefined
		});
	}

	handleUpdatedElement = (element) =>
	{
		const component = this, props = this.props, state = this.state;

		let state_element = state.elements
		.find((e, index) => index === element._index || e.id && e.id === element.id);

		_.merge(state_element, element);

		component.setState(
		{
			elements: state.elements
		});
	}

	handleDeletedElement = (id) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			elements: state.elements
				.filter((element, key) => element.id !== id && key !== id)
		});
	}

	updateCustomQuote = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		component.setState(
		{
			loading: true
		});

		qwest.post('/custom-quote/update',
		{
			elements: state.elements,
			title: state.form_data['title'],
			admin_email: state.form_data['admin_email'],
			id: state.id
		})
		.then(function (xhr, response)
		{
			component.setState(
			{
				loading: false,

				updated: [true, 'true'].includes(response.success),
			});
		})
		.catch (function (error, xhr, response)
		{
			console.error(error, xhr, response);

			component.setState({ loading: false });
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		let loader;

		if (component.state.loading === true)
		{
			loader =
			(
				<Loader className="c-loader"
					bemit={ ['white', 'bg-primary', 'CustomQuote'] } />
			);
		}

		let update_msg;

		if (state.updated === true)
		{
			update_msg =
			(
				<div className="c-message c-message--green c-message--full-width u-margin-top-20">
					<div className="c-message__content">
						<span>Mise à jour réussie.</span>
					</div>
				</div>
			);
		}

		var output =
		(
			<div className="c-form u-margin-top-0">
				<div className="c-title c-title--form">
					<div className="c-title__txt">
						Modification d'une demande de devis
					</div>
				</div>

				<CustomQuoteElements elements={ state.elements } editable={ false }
					onDeletion={ component.handleDeletedElement } updatable={ true } />

				<button type="button" className="c-btn" onClick={
					function (e) { app.emit('open__CustomQuoteItemModal'); } }>
					+ Ajouter un élément
				</button>

				<FormElement className="u-margin-top-20 u-uppercase"
					type="text" name="title" data={ state.form_data }
					placeholder="Afin de la retrouver plus facilement"
					label="Titre de la demande de devis"
					onChange={ handleChange.bind(component) } />

				<FormElement className="u-margin-top-20"
					type="email" name="admin_email" data={ state.form_data }
					placeholder="Destinataire"
					label="E-mail destinataire de la demande"
					onChange={ handleChange.bind(component) } />

				{ update_msg }

				<button type="button" className="c-btn c-btn--extra c-btn--next
					u-margin-top-20"
					onClick={ component.updateCustomQuote }>
					Mettre à jour le devis
					{ loader }
				</button>

			</div>
		);

		return output;
	}
}